<template>
    <div class="container-fluid">
        <fe-form
            :fe-id="$route.params.id"
            @back="$router.back()"
        />
    </div>
</template>
<script>
import FeForm from './FormComponent';
export default {
    components: {
        FeForm,
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/fireExtinguishers/EditComponent.vue